export enum PAGE_TYPE {
    'BASE' = 'base',
    'MOTOR' = 'motor',
}
